import React from "react";

/**
 * Heritage Career College custom logo (pure SVG)
 * Minimalist geometric "H" mark with a small star/spark accent + wordmark.
 */
export const HeritageLogo = ({ variant = "full", className = "", onDark = false }) => {
  const wordPrimary = onDark ? "#FDFBF7" : "#0F172A";
  const wordSecondary = onDark ? "#CBD5E1" : "#475569";
  const markColor = "#87CEEB";
  const markDeep = "#6B9AC4";

  if (variant === "mark") {
    return (
      <svg
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-label="Heritage Career College logo mark"
      >
        <rect x="10" y="12" width="9" height="40" rx="2" fill={markColor} />
        <rect x="45" y="12" width="9" height="40" rx="2" fill={markDeep} />
        <rect x="19" y="29" width="26" height="6" rx="1.5" fill={markColor} />
        <g transform="rotate(45 50 8)">
          <rect x="47" y="5" width="6" height="6" rx="1" fill="#0F172A" />
        </g>
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 320 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Heritage Career College of Business and Technology"
    >
      {/* Mark */}
      <rect x="6" y="12" width="9" height="40" rx="2" fill={markColor} />
      <rect x="41" y="12" width="9" height="40" rx="2" fill={markDeep} />
      <rect x="15" y="29" width="26" height="6" rx="1.5" fill={markColor} />
      <g transform="rotate(45 46 8)">
        <rect x="43" y="5" width="6" height="6" rx="1" fill={wordPrimary} />
      </g>
      {/* Wordmark */}
      <text
        x="68"
        y="30"
        fontFamily="'Playfair Display', Georgia, serif"
        fontWeight="700"
        fontSize="22"
        fill={wordPrimary}
        letterSpacing="1"
      >
        HERITAGE
      </text>
      <text
        x="68"
        y="48"
        fontFamily="'Manrope', system-ui, sans-serif"
        fontWeight="600"
        fontSize="9"
        letterSpacing="3"
        fill={wordSecondary}
      >
        CAREER COLLEGE · ONTARIO
      </text>
    </svg>
  );
};

export default HeritageLogo;
